import type { Coding } from '@medplum/fhirtypes'
import type { CodingDetails } from '@seen/core/codings'
import type { ObservationNodeAttributes } from '#src/components/rich-text-editor/ObservationNode/types.ts'

export interface ObservationNodeContent {
  type: 'observation'
  attrs: Partial<ObservationNodeAttributes>
}

// The observation node that records a code, captured the way its details
// say. What the @ picker inserts, and what a computed node adds for an
// input it is missing.
export function observationNodeContent(
  coding: Pick<Coding, 'system' | 'code'>,
  details: CodingDetails
): ObservationNodeContent {
  return {
    type: 'observation',
    attrs: {
      display: details.display,
      codingDisplay: details.display,
      system: coding.system,
      code: coding.code,
      scaleType: details.scaleType,
      unit: details.unit,
      answerOptions: details.answerOptions,
      answerValueSet: details.answerValueSet ?? null,
      referenceResourceType: details.referenceResourceType ?? null,
      valueKind: details.valueKind ?? null,
      repeats: details.repeats === true,
    },
  }
}
